import { render, staticRenderFns } from "./CallButton.vue?vue&type=template&id=28d87b84&"
import script from "./CallButton.vue?vue&type=script&lang=js&"
export * from "./CallButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports